import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DefaultHeader from "../../shared/DefaultHeader";
import DefaultFooter from "../../shared/DefaultFooter";
import { classNames } from "../../helpers/classNames";
import { useEffect } from "react";

const UserLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { myBooks, booksLoading } = useSelector((state) => state.profile);
  const { coverImages } = useSelector((state) => state.sketch);
  // const { activeBookId } = useSelector(state => state.stepFlow)
  const isCheckoutPage = location.pathname.includes("checkout");

  useEffect(() => {
    if (!myBooks.length && !location.pathname.includes("create-book") && !booksLoading) {
      navigate("/create-book?stepCode=Create_New_Book");
    }

    if (location.pathname.includes("cover-image") && !coverImages?.length) {
      navigate("/dashboard?stepCode=Upload_Your_Cover_Photo");
    }
  }, [location.pathname, !!myBooks?.length, !!coverImages?.length, booksLoading]);

  return (
    <>
      <DefaultHeader />
      <section className="relative py-10 lg:py-14 2xl:py-16  bg-md-pink-light-2">
        <div className={classNames("relative w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-[820px] mx-auto")}>
          {isCheckoutPage ? (
            <div className="relative flex-shrink flex-grow">
              <Outlet />
            </div>
          ) : (
            <div className="flex items-start gap-4 3xl:gap-6">
              <div className="relative flex-shrink flex-grow">
                <Outlet />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default UserLayout;
